import { render, staticRenderFns } from "./FreightFees.vue?vue&type=template&id=46dffea7&scoped=true&"
import script from "./FreightFees.vue?vue&type=script&lang=ts&"
export * from "./FreightFees.vue?vue&type=script&lang=ts&"
import style0 from "./FreightFees.vue?vue&type=style&index=0&id=46dffea7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dffea7",
  null
  
)

export default component.exports